/**
 * Redaksjonell "01 / Om"-etikett. Pure CSS via .section-label in global.css.
 * Brukes over seksjonsoverskrifter for en rolig rytme.
 */
export function SectionLabel({ index, children }: { index: number; children: string }) {
  return (
    <span className="section-label">
      <span aria-hidden>{String(index).padStart(2, "0")}</span>
      <span>/ {children}</span>
    </span>
  );
}
